import images from '@assets/images/index'
import { EditTeamFormClassOptions } from '@utils/Variables'
import { objToSelOpts } from '@utils/enumHelper'
import { Col, Form, Input, Row } from 'antd'

import { useFramework } from '@suntex.fim/framework'
import { Select } from '@suntex.fim/ui'

function EditTeamForm({
  summaryData,
  grade,
  setGrade,
  TLName,
  setTLName,
  className,
  setClassName
}: {
  summaryData: any
  grade: number
  setGrade: (grade: number) => void
  TLName: string
  setTLName: (tlName: string) => void
  className: string
  setClassName: (className: string) => void
}) {
  const { localization } = useFramework()
  const classOptions = objToSelOpts(EditTeamFormClassOptions).map((option) => ({
    ...option,
    label: localization.text(option.label)
  }))

  return (
    <Form layout="vertical">
      <Row gutter={[20, 20]}>
        <Col span={12}>
          <Form.Item colon={false} label="Team Name" required>
            {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */}
            <Input disabled value={summaryData?.info?.name} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item colon={false} label="School Name" required>
            {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */}
            <Input disabled value={summaryData?.info?.schoolName} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item colon={false} label="Team Leader User ID" required>
            {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */}
            <Input disabled value={summaryData?.info?.userId} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item colon={false} label="Password" required>
            <Input.Password
              // TODO :

              iconRender={(visible) =>
                visible ? <images.Eye /> : <images.EyeSlash />
              }
              placeholder="team-pass"
              readOnly
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
              value={summaryData?.info?.password}
              disabled
              style={{
                color: 'gray',
                background: '#f5f5f5',
                height: '46px',
                border: '0.1px solid'
              }}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item colon={false} label="Team Leader Display Name">
            <Input value={TLName} onChange={(e) => setTLName(e.target.value)} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item colon={false} label="Co-teachers:" required>
            <Input
              disabled
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
              value={summaryData?.coTeachers?.map(
                (coTeacher: string) => `${coTeacher} `
              )}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item colon={false} label={localization.text('Team Grade')}>
            <Select.One
              value={grade}
              onChange={(val) => setGrade(val)}
              options={classOptions}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item colon={false} label="Class Name" required>
            <Input
              value={className}
              onChange={(e) => setClassName(e.target.value)}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

export default EditTeamForm
